<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết KH tiềm năng</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="openListDevice()"
          v-if="dataMerchant?.customerId"
        >
          <i class="bx bxs-send"></i> Gửi TB cho MC nguồn CTV
        </button>
      </div>
    </div>
    <div v-if="loading" class="card-body p-10 b-t-1-869fb229 text-center">
      <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
    </div>

    <div v-else class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12"></div>
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="col-sm-6">
                  <div class="form-detail">
                    <h1>Thông tin chung</h1>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tên Merchant<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.merchantName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tên người đại diện <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.customerName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Email <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.email }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số điện thoại <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.mobile }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Địa chỉ <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.address }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngành nghề<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.mcc | transformData(systemConfig.businessFields) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataMerchant.mcc">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngành nghề chi tiết<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.mccDetail }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Loại MC<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.customerType | fomatCustomtype }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Độ ưu tiên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.rating | transformData(dataRating) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Nhân viên triển khai<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.activeSaleName }} - {{ dataMerchant.activeSaleEmail }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataMerchant.teleSaleName">
                      <label for="" class="col-sm-4 col-form-label"
                        >Nhân viên tư vấn<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.teleSaleName }} - {{ dataMerchant.teleSaleEmail }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataMerchant.expectedSignDate &&
                        dataMerchant.expectedSignDate !== null &&
                        dataMerchant.expectedSignDate !== '' &&
                        dataMerchant.referSource === 'AGENCY'
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Dự kiến ký HĐ<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.expectedSignDate | formatDate }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Trạng thái<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <span
                            class="badge"
                            v-bind:class="[
                              dataMerchant.salesProcess ? dataMerchant.salesProcess : '',
                            ]"
                          >
                            {{ dataMerchant.salesProcess | mapTextStatus(listState) }}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.createAt | formatHour1 }}
                          {{ dataMerchant.createAt | formatDate1 }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian cập nhật<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.modifiedAt | formatHour1 }}
                          {{ dataMerchant.modifiedAt | formatDate1 }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian chuyển đổi<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.verifyDate | formatHour1 }}
                          {{ dataMerchant.verifyDate | formatDate1 }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian tư vấn cuối<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.lastCareDate | formatHour1 }}
                          {{ dataMerchant.lastCareDate | formatDate1 }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Nguồn tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <b>{{ dataMerchant.referSource | mapTextStatus(sourceCreate) }}</b> <br />
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Cộng tác viên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <label
                            v-if="
                              dataMerchant.agentName !== null || dataMerchant.agentMobile !== null
                            "
                          >
                            {{ dataMerchant.agentName }} - {{ dataMerchant.agentMobile }}
                          </label>
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Xếp hạng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <span class="bage badge-pill rateLead"
                          ><span v-if="dataMerchant.tag"
                            >{{ dataMerchant.tag | transformData(Config.tagLead) }} :</span
                          >
                          {{ dataMerchant.score }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Có GPDKKD không<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.licenseBusiness
                              | transformData(systemConfig.licenseBusiness)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Vị trí cửa hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.storeLocation
                              | transformData(systemConfig.storeLocation)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Giá trị TB đơn hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.averageOrder
                              | transformData(systemConfig.averageOrder)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Người mua hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.averageAge
                              | transformData(systemConfig.averageAge)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số lượng cửa hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.extraInfo.numberOfShop }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số lượng nhân viên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.extraInfo.numberOfStaff }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Người thu ngân<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.extraInfo.cashier | transformData(systemConfig.cashier) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã biết MPOS chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.knowMPOS | transformData(systemConfig.knowMPOS)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.listServiceType">
                      <label for="" class="col-sm-4 col-form-label"
                        >Dịch vụ quan tâm<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataMerchant.listServiceType"
                          :key="index"
                        >
                          {{ item.serviceType | transformData(systemConfig.services) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="
                        dataMerchant.extraInfo && dataMerchant.extraInfo.lstPaymentMethodSuggest
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >PT Thanh toán quan tâm<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataMerchant.extraInfo.lstPaymentMethodSuggest"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.paymentMethod) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có POS chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataMerchant.extraInfo.ownPOS | transformData(systemConfig.ownPOS) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="dataMerchant.extraInfo && dataMerchant.extraInfo.lstPos"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >POS bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataMerchant.extraInfo.lstPos"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.posBank) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có VietQR chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.hasVietQr | transformData(systemConfig.hasVietQr)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataMerchant.extraInfo && dataMerchant.extraInfo.lstVietQrBank"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >VietQR bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataMerchant.extraInfo.lstVietQrBank"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.vietQrBank) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataMerchant.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có Trả góp chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataMerchant.extraInfo.hasInstallment
                              | transformData(systemConfig.hasInstallment)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataMerchant.extraInfo && dataMerchant.extraInfo.lstInstallmentBank"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Trả góp bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataMerchant.extraInfo.lstInstallmentBank"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.installmentBank) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ghi chú <span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataMerchant.description }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row mb-2 img-list">
                      <label class="col-sm-4 col-form-label f12">Ảnh</label>
                      <div class="mt-2">
                        <ul class="list-img" v-viewer>
                          <li v-for="(image, index) in dataMerchant.uploadImages" :key="index">
                            <a href="javascript:void(0)" data-toggle="modal">
                              <img :src="image" alt="" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <ListTask
                    :id="customerId"
                    purposeType="MERCHANT"
                    :isProcessed="false"
                    :isShowAdd="true"
                  />
                  <ListTask :id="customerId" purposeType="MERCHANT" :isProcessed="true" />
                  <div class="form-detail">
                    <h1>Hợp đồng</h1>
                    <div class="table-responsive" v-if="infoContract.length > 0">
                      <table class="table table-hover table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col">Số hợp đồng</th>
                            <th scope="col">Dịch vụ</th>
                            <th scope="col">Trạng thái</th>
                            <th scope="col">Nhân viên chăm sóc</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in infoContract" :key="index" class="table-row">
                            <td>
                              <div>Số: {{ item.code }}</div>
                              <div>
                                TG tạo: {{ item.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                              </div>
                            </td>
                            <td>
                              {{ item.service | serviceTypes }}
                            </td>
                            <td>
                              <span class="badge" v-bind:class="[item.status ? item.status : '']"
                                >{{ item.status | mapTextStatus(listStatusContract) }}
                              </span>
                            </td>
                            <td>
                              <p>
                                <b>{{ item.saleInfo ? item.saleInfo.name : '' }}</b>
                              </p>
                              <p>
                                <a href="javascript:void(0)">{{
                                  item.saleInfo ? item.saleInfo.userName : ''
                                }}</a>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-center">Không có dữ liệu</div>
                  </div>

                  <div class="form-detail">
                    <h1>Lịch sử gán</h1>
                    <div class="table-responsive" v-if="dataAssignHistory.length > 0">
                      <table class="table table-hover table-bordered" id="tableScroll">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col">Thời gian</th>
                            <th scope="col">NV tư vấn</th>
                            <th scope="col">NV triển khai</th>
                            <th scope="col">Người gán</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in dataAssignHistory"
                            :key="index"
                            class="table-row"
                          >
                            <td>
                              {{ item.assignedAt | formatDate('HH:mm DD/MM/YYYY') }}
                            </td>
                            <td>
                              <p>{{ item.teleSaleName }}</p>
                              <p>{{ item.teleSaleEmail }}</p>
                            </td>
                            <td>
                              <p>{{ item.activeSaleName }}</p>
                              <p>{{ item.activeSaleEmail }}</p>
                            </td>
                            <td>
                              <p>{{ item.createdByName }}</p>
                              <p>{{ item.createdByEmail }}</p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="text-center">Không có dữ liệu</div>
                  </div>

                  <DeviceShipments :customerId="customerId" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopupListDevice ref="listTbActiveRef" @onLoad="fetchData" />
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { AgentService } from '@/services/agent.service'
  import Config from '../../thirdParty/config'
  import { MerchantPotentialService } from '@/services/merchantPotential.service'
  import ListTask from '@/components/Merchant/ListTask.vue'
  import merchantMx from '../../mixins/merchantMx'
  import PopupListDevice from '@/components/common/PopupListDevice.vue'
  import DeviceShipments from '@/components/common/DeviceShipments.vue'

  export default {
    mixins: [merchantMx],
    components: { ListTask, PopupListDevice, DeviceShipments },
    data() {
      return {
        customerId: this.$route.params.customerId,
        typeSale: JSON.parse(localStorage.getItem('userData')).typeSale,
        listAfterSale: Config.listAfterSale,
        businessFields: Config.businessFields,
        dataMerchant: [],
        infoMC: {},
        groupServiceKey: {},
        listState: Config.listStatusMC,
        sourceCreate: [
          { text: 'Sales', id: 'SALES' },
          { text: 'Cộng tác viên', id: 'AGENCY' },
          { text: 'Marketing', id: 'MARKETING' },
        ],
        dataWorkHistory: [],
        dataResultAction: [
          { id: 'SUITABLE', text: 'Phù hợp' },
          { id: 'MEET_FAIL', text: 'Không liên hệ được' },
          { id: 'NO_CARE', text: 'Chưa quan tâm' },
          { id: 'DUPLICATE', text: 'Trùng thông tin' },
          { id: 'WRONG', text: 'Sai thông tin' },
          { id: 'HAS_SERVICE', text: 'Đã sử dụng dịch vụ' },
          { id: 'OTHER', text: 'Khác' },
        ],
        infoContract: [],
        listStatusContract: Config.listStatusContract,
        dataCareHistory: [],
        dataAssignHistory: [],
        loading: false,
        dataRating: [
          { id: '0', text: 'Tất cả' },
          { id: 'HOT', text: 'Ưu tiên' },
          { id: 'WARM', text: 'Thường' },
          { id: 'COLD', text: 'Không ưu tiên' },
        ],
        Config,
      }
    },

    filters: {
      // lấy giờ tạo
      formatHour1(date) {
        if (!date) return '--:--'
        return date.substring(10, 16)
      },
      // lấy ngày tạo
      formatDate1(date) {
        if (!date) return '--:--'
        return date.substring(0, 10)
      },
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },

    async mounted() {
      this.loading = true
      await this.fetchData()
      await this.fetchWorkHistory()
      await this.fetchCareHistory()
      await this.contractInfo()
      await this.fetchAssignHistory()
      this.getConfigSystem()
      this.loading = false
    },

    methods: {
      openListDevice() {
        this.$refs.listTbActiveRef.show(this.dataMerchant?.customerId || this.customerId || '')
      },
      backToList() {
        if (this.$route.query.from === 'leads') this.$router.push('/leads')
        else this.$router.push('/potential-customers')
      },
      async getServiceList() {
        try {
          const data = await AgentService.getServiceList()
          if (data.success) {
            data.data.groupService.map(e => {
              this.groupServiceKey[e.service] = e.name
            })
          }
        } catch (error) {}
      },
      async fetchData() {
        try {
          const data = await MerchantService.merchantDetail({
            customerId: this.customerId,
          })
          if (data.success) {
            this.dataMerchant = data.data
          }
        } catch (error) {}
      },
      async fetchWorkHistory() {
        try {
          const data = await MerchantPotentialService.getWorkHistory({
            customerId: this.customerId,
          })
          if (data.code === 1000) {
            this.dataWorkHistory = data.data ? data.data : []
          }
        } catch (error) {}
      },

      async fetchCareHistory() {
        try {
          const data = await MerchantPotentialService.getCareHistory({
            customerId: this.customerId,
          })
          if (data.code === 1000) {
            this.dataCareHistory = data.data ? data.data : []
          }
        } catch (error) {}
      },
      async contractInfo() {
        try {
          const data = await MerchantPotentialService.getListContract({
            limit: 20,
            page: 1,
            customerId: this.customerId,
          })
          if (data.success) {
            this.infoContract = data.data.contractList ? data.data.contractList : []
          }
        } catch (error) {}
      },
      async fetchAssignHistory() {
        try {
          const data = await MerchantPotentialService.getAssignHistory({
            customerId: this.customerId,
          })
          if (data.success) {
            this.dataAssignHistory = data.data ? data.data : []
          }
        } catch (error) {}
      },
    },
  }
</script>

<style scoped>
  .NEW {
    color: #fff;
    background-color: #707b7c;
  }
  .POTENTIAL {
    color: #fff;
    background-color: #f1c40f;
  }
  .HAS_CONTRACT {
    color: #fff;
    background-color: #28a745;
  }
  .APPROVAL {
    color: #fff;
    background-color: #1d8348;
  }
  .HANDOVER {
    color: #fff;
    background-color: #17a2b8;
  }
  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
  .REJECT {
    color: #fff;
    background-color: #dc3545;
  }
</style>
